// extracted by mini-css-extract-plugin
module.exports = {"num_text":"NumText_num_text__g_mY2","item":"NumText_item__RQQzD"};